import React from 'react';
import { Router, browserHistory } from 'react-router';

import { currentArea } from './areas';

const RootRouter = () => {
  const routes = currentArea.routes;

  // Similar to an 'onChange' handler, this can be any function(s) we need when the route changes
  const onRouterUpdate = () => {
    if (window.location.pathname !== window.previousPathname) {
      window.scrollTo(0, 0);
    }
    window.previousPathname = window.location.pathname;
  };

  return (
    <Router
      onUpdate={onRouterUpdate}
      history={browserHistory}
    >
      {routes}
    </Router>
  );
};

export default RootRouter;



// WEBPACK FOOTER //
// ./src/routes/index.js